(function () {
  function init(section) {
    var id = section.dataset.sectionId;
    var storesUrl = section.dataset.storesUrl;
    var searchEl = document.getElementById('store-locator-search-' + id);
    var stateEl = document.getElementById('store-locator-state-' + id);
    var cityEl = document.getElementById('store-locator-city-' + id);
    var locateEl = document.getElementById('store-locator-locate-' + id);
    var listEl = document.getElementById('store-locator-list-' + id);
    var mapEl = document.getElementById('store-locator-map-' + id);

    var mapInstance = null;
    var markers = {};
    var stores = [];
    var active = null;

    function waitForLeaflet(cb) {
      if (window.L) { cb(); return; }
      var tries = 0;
      var t = setInterval(function () {
        if (window.L) { clearInterval(t); cb(); }
        else if (++tries > 60) { clearInterval(t); }
      }, 100);
    }

    function buildMap() {
      var centerLat = parseFloat(section.querySelector('[data-default-lat]')?.dataset.defaultLat || '17.4');
      var centerLng = parseFloat(section.querySelector('[data-default-lng]')?.dataset.defaultLng || '78.5');
      mapInstance = L.map(mapEl, { scrollWheelZoom: false }).setView([centerLat, centerLng], 5);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap'
      }).addTo(mapInstance);

      var pinSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="38" viewBox="0 0 28 38">' +
          '<path d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 24 14 24s14-13.5 14-24C28 6.27 21.73 0 14 0z" fill="#2E7D32" stroke="#1B5E20" stroke-width="1"/>' +
          '<circle cx="14" cy="14" r="5" fill="#fff"/>' +
        '</svg>';
      var greenIcon = L.divIcon({
        className: 'store-locator__pin',
        html: pinSvg,
        iconSize: [28, 38],
        iconAnchor: [14, 38],
        popupAnchor: [0, -34]
      });

      stores.forEach(function (s) {
        if (s.lat == null || s.lng == null) return;
        var m = L.marker([s.lat, s.lng], { icon: greenIcon }).addTo(mapInstance);
        m.bindPopup(
          '<strong>' + escapeHtml(s.name) + '</strong>' +
          '<div>' + escapeHtml(s.address || '') + '</div>' +
          '<div><a target="_blank" rel="noopener" href="' + directionsUrl(s) + '">Get directions</a></div>'
        );
        m.on('click', function () { setActive(s.code); });
        markers[s.code] = m;
      });

      fitToVisible(stores);
    }

    function fitToVisible(list) {
      if (!mapInstance) return;
      var pts = list.filter(function (s) { return s.lat != null && s.lng != null; })
                    .map(function (s) { return [s.lat, s.lng]; });
      if (pts.length === 0) return;
      if (pts.length === 1) { mapInstance.setView(pts[0], 13); return; }
      mapInstance.fitBounds(pts, { padding: [40, 40] });
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function directionsUrl(s) {
      if (s.lat != null && s.lng != null) {
        return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
      }
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.address || s.name);
    }

    function uniqSorted(values) {
      return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
        return a.localeCompare(b);
      });
    }

    function populateFilters() {
      uniqSorted(stores.map(function (s) { return s.state; })).forEach(function (v) {
        var o = document.createElement('option'); o.value = v; o.textContent = v; stateEl.appendChild(o);
      });
      refreshCities();
    }

    function refreshCities() {
      var selState = stateEl.value;
      while (cityEl.options.length > 1) cityEl.remove(1);
      var cities = uniqSorted(stores
        .filter(function (s) { return !selState || s.state === selState; })
        .map(function (s) { return s.city; }));
      cities.forEach(function (v) {
        var o = document.createElement('option'); o.value = v; o.textContent = v; cityEl.appendChild(o);
      });
    }

    function currentFilter() {
      var q = (searchEl.value || '').trim().toLowerCase();
      var st = stateEl.value;
      var ct = cityEl.value;
      return stores.filter(function (s) {
        if (st && s.state !== st) return false;
        if (ct && s.city !== ct) return false;
        if (!q) return true;
        var hay = [s.name, s.code, s.city, s.state, s.address].join(' ').toLowerCase();
        return hay.indexOf(q) > -1;
      });
    }

    function renderList() {
      var filtered = currentFilter();
      listEl.innerHTML = '';
      if (filtered.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'store-locator__empty';
        empty.textContent = 'No stores match your search.';
        listEl.appendChild(empty);
        return;
      }
      filtered.forEach(function (s) {
        var card = document.createElement('article');
        card.className = 'store-card' + (s.code === active ? ' is-active' : '');
        card.dataset.code = s.code;
        card.innerHTML =
          '<h3 class="store-card__name">' + escapeHtml(s.name) + '</h3>' +
          '<p class="store-card__meta">' + escapeHtml([s.city, s.state].filter(Boolean).join(', ')) +
          (s.code ? ' &middot; ' + escapeHtml(s.code) : '') + '</p>' +
          '<p class="store-card__address">' + escapeHtml(s.address || '') + '</p>' +
          '<div class="store-card__actions">' +
            '<a class="store-card__link" target="_blank" rel="noopener" href="' + directionsUrl(s) + '">Directions</a>' +
          '</div>';
        card.addEventListener('click', function () { setActive(s.code, true); });
        listEl.appendChild(card);
      });

      fitToVisible(filtered);
    }

    function setActive(code, flyTo) {
      active = code;
      var s = stores.find(function (x) { return x.code === code; });
      Array.prototype.forEach.call(listEl.querySelectorAll('.store-card'), function (el) {
        el.classList.toggle('is-active', el.dataset.code === code);
      });
      if (s && markers[code] && mapInstance) {
        if (flyTo && s.lat != null && s.lng != null) {
          mapInstance.flyTo([s.lat, s.lng], 14, { duration: 0.6 });
        }
        markers[code].openPopup();
      }
      var activeEl = listEl.querySelector('.store-card.is-active');
      if (activeEl) activeEl.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    function haversine(a, b) {
      var R = 6371;
      var toRad = function (x) { return x * Math.PI / 180; };
      var dLat = toRad(b[0] - a[0]);
      var dLng = toRad(b[1] - a[1]);
      var lat1 = toRad(a[0]), lat2 = toRad(b[0]);
      var h = Math.sin(dLat / 2) ** 2 + Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }

    function locateMe() {
      if (!navigator.geolocation) return;
      locateEl.disabled = true;
      navigator.geolocation.getCurrentPosition(function (pos) {
        locateEl.disabled = false;
        var here = [pos.coords.latitude, pos.coords.longitude];
        stores.sort(function (a, b) {
          if (a.lat == null) return 1;
          if (b.lat == null) return -1;
          return haversine(here, [a.lat, a.lng]) - haversine(here, [b.lat, b.lng]);
        });
        if (mapInstance) mapInstance.flyTo(here, 11);
        renderList();
      }, function () {
        locateEl.disabled = false;
        alert('Could not get your location.');
      }, { enableHighAccuracy: true, timeout: 8000 });
    }

    searchEl.addEventListener('input', renderList);
    stateEl.addEventListener('change', function () { refreshCities(); renderList(); });
    cityEl.addEventListener('change', renderList);
    locateEl.addEventListener('click', locateMe);

    fetch(storesUrl).then(function (r) { return r.json(); }).then(function (data) {
      stores = data || [];
      populateFilters();
      renderList();
      waitForLeaflet(buildMap);
    }).catch(function (err) {
      listEl.innerHTML = '<div class="store-locator__empty">Could not load store list.</div>';
      console.error('store-locator load error', err);
    });
  }

  function boot() {
    document.querySelectorAll('.store-locator[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
